var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestionMarkActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_question-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_question-mark"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E82E81",
    cx: 13,
    cy: 13,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9736842,15.6859875 C12.634562,15.6859875 12.3596491,15.411052 12.3596491,15.0719298 L12.3596491,13.2947368 C12.3596491,12.9556146 12.634562,12.6807018 12.9736842,12.6807018 C13.9881441,12.6807018 14.8105263,11.8583195 14.8105263,10.8438596 C14.8105263,9.82939977 13.9881441,9.00701754 12.9736842,9.00701754 C11.9592243,9.00701754 11.1368421,9.82939977 11.1368421,10.8438596 C11.1368421,11.1829819 10.8619292,11.4578947 10.522807,11.4578947 C10.1836848,11.4578947 9.90877193,11.1829819 9.90877193,10.8438596 C9.90877193,9.23178076 11.1576466,7.89527914 12.7660209,7.78605262 C14.3743952,7.6768261 15.7924642,8.83221477 16.0104476,10.4294879 C16.228431,12.0267611 15.171809,13.5198763 13.5929825,13.845614 L13.5929825,15.0736842 C13.5925214,15.2371482 13.5269008,15.3936813 13.4106572,15.5086077 C13.2944135,15.6235341 13.1371428,15.6873667 12.9736842,15.6859875 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9736842,18.1684211 C12.6326242,18.1684211 12.3561404,17.8919372 12.3561404,17.5508772 C12.3561404,17.2098171 12.6326242,16.9333333 12.9736842,16.9333333 C13.3147443,16.9333333 13.5912281,17.2098171 13.5912281,17.5508772 C13.5893111,17.89114 13.313947,18.166504 12.9736842,18.1684211 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMarkActive);
export default __webpack_public_path__ + "static/media/icon_question-mark-active.0296cc346facce234eadf8a43c0e4af5.svg";
export { ForwardRef as ReactComponent };